import { useContext } from "react";
import useMediaWithInitialState from "./useMediaWithInitialState";
import MobileDetectContext from "../../components/MobileDetectContext";

export default function useIsPhone() {
  const mobileDetectContext = useContext(MobileDetectContext);
  return useMediaWithInitialState("(max-width: 380px)", mobileDetectContext.isPhone);
}
